import React from "react";
import {
  Bar,
  BarChart,
  CartesianGrid,
  Legend,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";

import { chartColors } from "../../clients-dashboard-style";
import { getHiringsChartData } from "./helpers";
import { TicksProps } from "../../clients-dashboard-types";
import { IGetHiringsData } from "../../../../../services/ClientsDashboardServices.dto";

const HiringsChart = ({ data }: { data: IGetHiringsData }) => {
  const [activeSeries, setActiveSeries] = React.useState<Array<string>>([]);

  const handleLegendClick = (dataKey: string) => {
    // Desactiva y activa las barras de los productos seleccionados
    if (activeSeries.includes(dataKey)) {
      setActiveSeries(activeSeries.filter((el) => el !== dataKey));
    } else {
      setActiveSeries((prev) => [...prev, dataKey]);
    }
  };

  const newData = getHiringsChartData(data, false, true);
  const productTypes = Object.keys(newData[0]);

  const renderCustomTick = (tickProps: TicksProps) => {
    const { x, y, index } = tickProps;
    // Se busca la primera aparición de un año para mostrarlo una sóla vez
    const isYearChange = index === 0 || newData[index].year !== newData[index - 1].year;

    return (
      <g transform={`translate(${x},${y})`}>
        {isYearChange && (
          <>
            <text
              x={0}
              y={0}
              dy={-40}
              textAnchor="middle"
              fill="#666"
              fontSize={20}
              transform="rotate(-90)"
            >
              {newData[index].year}
            </text>
          </>
        )}
        <text x={-16} y={0} dy={0} textAnchor="middle" fill="#666">
          {newData[index].month}
        </text>
      </g>
    );
  };

  return (
    <ResponsiveContainer width="100%" height={800}>
      <BarChart
        width={500}
        height={300}
        data={newData}
        margin={{
          top: 20,
          right: 30,
          left: 20,
          bottom: 5,
        }}
        layout="vertical"
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis type="number" />
        <YAxis width={50} type="category" dataKey="month" tick={renderCustomTick} />
        <Tooltip />
        <Legend iconType="circle" onClick={(props) => handleLegendClick(props.dataKey)} />
        {productTypes.map((type: string, index) => {
          if (type === "month" || type === "year") return null;
          return (
            <Bar
              key={type}
              dataKey={type}
              fill={chartColors[index]}
              hide={activeSeries.includes(type)}
            />
          );
        })}
      </BarChart>
    </ResponsiveContainer>
  );
};

export default HiringsChart;
